import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const RegulationIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 54,
  height = 54,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M4.4 30.5l5.7-19 6.1 19m21.4 0l5.7-19 6.1 19"
          stroke="#000000"
          className={styles.defaultStrokeColour}
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M35.5 1c-2 0-4 .6-5.7 1.7a5.7 5.7 0 00-5-.1c-1.6-1-3.5-1.6-5.5-1.6-3.1 0-6.1 1.4-8.2 3a4 4 0 00-1.3-.3 4 4 0 103.5 6.3l.7-.5s2.6-2.3 5.3-2.3c.8 0 1.5.2 2.2.6a5.7 5.7 0 0011.4.2c.8-.6 1.7-.8 2.6-.8 1.5 0 3 .7 4 1.3a4.1 4.1 0 103.9-4.8c-1.5-1-4.5-2.7-8-2.7m0 2c3 0 5.6 1.5 6.9 2.4l.4.5a2.1 2.1 0 011-.2 2.1 2.1 0 11-2.2 1.6 1 1 0 01-.5-.1c-1.2-1-3.3-2-5.5-2-1.3 0-2.7.4-4 1.4a1 1 0 01-.7.3l.1.9a3.7 3.7 0 11-7.3-1l-.2-.2a6.3 6.3 0 00-4-1.4c-3.7 0-6.7 2.8-6.8 2.9a1 1 0 01-.7.2 2.1 2.1 0 11-2-2.6c.6 0 1 .3 1.4.6C13 4.8 16 3 19.3 3c1.8 0 3.7.6 5.4 2a3.7 3.7 0 015.2.2s0-.2.2-.2c1.8-1.5 3.6-2 5.4-2"
          fill="#00000"
          className={styles.defaultColor}
        />
        <path
          d="M35.1 48.2h-2c-.3-2.3-1.9-4.2-4-5V18.6c1.1-.7 1.6-1.9 1.6-3.3h-7.6c0 1.4.5 2.2 1.7 3.3v25c-2 .7-3.4 2.5-3.7 4.7h-2.8a4.2 4.2 0 00-4.3 4.2h25.4c0-2.3-2-4.2-4.3-4.2z"
          stroke="#000000"
          className={styles.defaultStrokeColour}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M15.8 48.8h22"
          stroke="#000000"
          className={styles.defaultStrokeColour}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g transform="translate(33 28.4)">
          <path
            d="M1.3.4a1 1 0 00-1 1c.5 5.3 5 9.4 10.2 9.4 5.3 0 9.7-4 10.3-9.3a1 1 0 00-1-1.1H1.3z"
            fill="#0050B3"
            className={styles.interactiveColor}
          />
        </g>
        <g transform="translate(0 28.4)">
          <path
            d="M1 .4a1 1 0 00-1 1c.6 5.3 5 9.4 10.2 9.4 5.4 0 9.7-4.1 10.3-9.3a1 1 0 00-1-1.1H1z"
            fill="#0050B3"
            className={styles.interactiveColor}
          />
        </g>
      </g>
    </Icon>
  )
}
